import React, { useEffect, useState } from "react";
import MainCard from "../../../components/Maincard";
import {
  Backdrop,
  Button,
  Chip,
  CircularProgress,
  Grid,
  MenuItem,
  Paper,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import LaunchOutlinedIcon from "@mui/icons-material/LaunchOutlined";
import InfoCard from "./InfoCard";
import CustomPopup from "../../../components/CustomPopup";
import SvoReportTable from "./SvoReportTable";
import CustomSnackbar from "../../components/ui-component/snackbar/CustomSnackbar";
import { useGetTokenOrLogout } from "../../../utils/token";
import { useNavigate } from "react-router-dom";
import CustomTextFieldComp from "../../newComponent/customTextFieldComp";
import SearchButton from "../../newComponent/NewButtonComp/SearchButton";
import ResetButtonComp from "../../newComponent/NewButtonComp/ResetButtonComp";
import NewCardcomp from "../../../components/card/NewCardcomp";
import HeadingCard from "../../newComponent/NewCardsComp/HeadingCard";
import { DataGrid } from "@mui/x-data-grid";
import CustomNoRowsOverlay from "../../newComponent/TableCustomeComp/CustomNoRowsOverlay";
import { useDateUtils } from "../../../utils/formatTime";
import LoaderComp from "../../newComponent/LoaderComp/Loader";
import SearchTextFieldComp from "../../newComponent/newtextfieldComp/SearchTextFieldComp";
import NewEnquiryComp from "../../../pages/AllUserDashboards/popupComponent/NewEnquiryComp";
import DemoDetails from "../AdvisorTaskWiseReport/DemoDetails";
import EnrollDetails from "../../../pages/AllUserDashboards/popupComponent/EnrollDetails";

const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;
export default function SvoReport() {
  const userId = localStorage.getItem("userId");
  const getTokenOrLogout = useGetTokenOrLogout();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [svoReportData, setSvoReportData] = useState([]);
  const [selectedOption, setSelectedOption] = useState("today");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setTodate] = useState("");
  const [loading, setLoading] = useState(false);
  const [testprepLoading, setTestPrepLoading] = useState(false);
  const [testpreData, setTestPrepData] = useState([]);
  const [originalData, setOriginalData] = useState([]);
  const [detailspopup, setDetailsPopup] = useState(false);
  const [detailsData, setDetailsData] = useState([]);
  const [detailsLoading, setDetailsLoading] = useState(false);
  const [selectedHeader, setSelectedHeader] = useState(null);
  const [selectedHeaderValue, setSelectedHeaderValue] = useState(null);
  const [rowData, setRowData] = useState({});

  const [snackbarOpen, setSnackbarOpen] = React.useState(false);
  const [snackbarMessage, setSnackbarMessage] = React.useState("");
  const [snackbarSeverity, setSnackbarSeverity] = React.useState("success");

  const today = new Date().toISOString().split("T")[0];
  const { currentMonthName, lastMonthName, weekRange } = useDateUtils();
  const showSnackbar = (message, severity) => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };

  const handleClick = (e) => {
    setFromDate(null);
    setTodate(null);
    setSelectedOption(e.target.value);
  };

  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const handleChangeFromDate = (e) => {
    setFromDate(e.target.value);
  };
  const handleChangeToDate = (e) => {
    setTodate(e.target.value);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    // Handle form submission logic here
    setLoading(true);
    const token = getTokenOrLogout();
    if (!token) return;
    let headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json", // Make sure to keep the content type
    };

    const requestData = {
      user_id: parseInt(userId),
      from_date: fromDate,
      to_date: toDate,
    };

    try {
      const response = await fetch(`${API_ENDPOINT}reports/getsvoreport`, {
        method: "POST",
        headers,
        body: JSON.stringify(requestData),
      });

      if (response.ok) {
        setLoading(false);
        const result = await response.json();

        setSvoReportData(result);
      } else if (response.status === 404) {
        navigate("/page404");
      } else if (response.status === 401) {
        navigate("/page401");
      } else if (response.status === 403) {
        navigate("/page403");
      } else if (response.status === 440) {
        navigate("/page440");
      } else {
        navigate("/page500");
      }
    } catch (error) {
      setLoading(false);
      console.error("Error:", error);
      showSnackbar(" Error", "error");
      navigate("/page500");
    }
  };

  const handleSubmitTestprep = async (event) => {
    setTestPrepLoading(true);

    // Handle form submission logic here

    const requestData = {
      user_id: parseInt(userId),
      filter: selectedOption,
      from_date: fromDate || null,
      to_date: toDate || null,
    };

    try {
      const response = await fetch(
        `${API_ENDPOINT}reports/getsvoreportwithsubservice`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestData),
        }
      );

        const result = await response.json();

      if (response.ok) {
        setTestPrepLoading(false);
      

        setTestPrepData(result);
        setOriginalData(result);
        // if (result.length !== 0) handleOpen();
      } else if (response.status === 403) {
        // Handle errors, e.g., show an error message
        setTestPrepLoading(false);
        showSnackbar("Unknown User", "error");
      } else if (response.status === 404) {
        setTestPrepLoading(false);
        showSnackbar("Please enter valid date", "error");
      } else if (response.status === 400) {
        setTestPrepLoading(false);
        showSnackbar(result.message, "error");
      } else {
        setTestPrepLoading(false);
        showSnackbar(" Server Error :" ,result.message , "error");
      }
    } catch (error) {
      setLoading(false);
      console.error("Error:", error);
      showSnackbar(" Server Error", "error");
    }
  };

  useEffect(() => {
    handleSubmitTestprep();
  }, []);

  const columns = [
    {
      field: "sub_service_id",
      headerName: "Sub Service",
      flex: 1.3,
      minWidth: 200,
      headerClassName: "header-cell",
      valueGetter: (params) => params.row?.name,
      renderCell: (params) => {
        const allRowIds = params.api.getAllRowIds();
        const isLastRow = params.id === allRowIds[allRowIds.length - 1];

        return (
          <div
            style={{
              fontWeight: !isLastRow ? 500 : 700,
              color: !isLastRow ? "" : "black",
            }}
          >
            {params.row?.name}
          </div>
        );
      },

      headerAlign: "center",
      align: "center",
    },

    {
      field: "totalEnquiries",
      headerName: "New Enquiries",
      flex: 1,
      minWidth: 150,
      headerClassName: "header-cell",
      headerAlign: "center",
      align: "center",
      valueGetter: (params) => params.value,
      renderCell: (params) => {
        const allRowIds = params.api.getAllRowIds();
        const isLastRow = params.id === allRowIds[allRowIds.length - 1];

        return (
          <div
            style={{
              fontWeight: !isLastRow ? 500 : 700,
              color: !isLastRow ? "blue" : "black",
              cursor: !isLastRow ? "pointer" : "",
            }}
            onClick={() =>
              isLastRow
                ? undefined
                : handleGetDetailsData(
                    params?.row,
                    "New Enquiry",
                    "client_count"
                  )
            }
          >
            {params.row?.totalEnquiries}
          </div>
        );
      },
    },
    {
      field: "demoBookedCount",
      headerName: "Demo Scheduled",
      flex: 1,
      minWidth: 150,
      headerClassName: "header-cell",
      valueGetter: (params) => params.value,
      renderCell: (params) => {
        const allRowIds = params.api.getAllRowIds();
        const isLastRow = params.id === allRowIds[allRowIds.length - 1];

        return (
          <div
            style={{
              fontWeight: !isLastRow ? 500 : 700,
              color: !isLastRow ? "blue" : "black",
              cursor: !isLastRow ? "pointer" : "",
            }}
            onClick={() =>
              isLastRow
                ? undefined
                : handleGetDetailsData(
                    params?.row,
                    "Demo Scheduled",
                    "demo_scheduled"
                  )
            }
          >
            {params.row?.demoBookedCount}
          </div>
        );
      },

      headerAlign: "center",
      align: "center",
    },
    {
      field: "enrolledCount",
      headerName: "Enrolled",
      flex: 1,
      minWidth: 150,
      headerClassName: "header-cell",
      valueGetter: (params) => params.value,
      renderCell: (params) => {
        const allRowIds = params.api.getAllRowIds();
        const isLastRow = params.id === allRowIds[allRowIds.length - 1];

        return (
          <div
            style={{
              fontWeight: !isLastRow ? 500 : 700,
              color: !isLastRow ? "blue" : "black",
              cursor: !isLastRow ? "pointer" : "",
            }}
            onClick={() =>
              isLastRow
                ? undefined
                : handleGetDetailsData(params?.row, "Enrolled", "enrolled")
            }
          >
            {params.row?.enrolledCount}
          </div>
        );
      },
      headerAlign: "center",
      align: "center",
    },
    {
      field: "superprospectiveCount",
      headerName: "Super Prospective",
      flex: 1,
      minWidth: 150,
      headerClassName: "header-cell",
      renderCell: (params) => {
        const allRowIds = params.api.getAllRowIds();
        const isLastRow = params.id === allRowIds[allRowIds.length - 1];

        return (
          <div
            style={{
              fontWeight: !isLastRow ? 500 : 700,
              color: !isLastRow ? "blue" : "black",
              cursor: !isLastRow ? "pointer" : "",
            }}
            onClick={() =>
              isLastRow
                ? undefined
                : handleGetDetailsData(
                    params?.row,
                    "Super Prospective",
                    "super_prospective"
                  )
            }
          >
            {params.row?.superprospectiveCount}
          </div>
        );
      },
      headerAlign: "center",
      align: "center",
    },
    {
      field: "recycledCount",
      headerName: "Recycled",
      flex: 1,
      minWidth: 150,
      headerClassName: "header-cell",
      renderCell: (params) => {
        const allRowIds = params.api.getAllRowIds();
        const isLastRow = params.id === allRowIds[allRowIds.length - 1];

        return (
          <div
            style={{
              fontWeight: !isLastRow ? 500 : 700,
              color: !isLastRow ? "blue" : "black",
              cursor: !isLastRow ? "pointer" : "",
            }}
            onClick={() =>
              isLastRow
                ? undefined
                : handleGetDetailsData(
                    params?.row,
                    "Recycled",
                    "recycled"
                  )
            }
          >
            {params.row?.recycledCount}
          </div>
        );
      },
      headerAlign: "center",
      align: "center",
    },
  ];

  const handleChangeNmae = (e) => {
    const value = e.target.value;

    // Filter data immediately
    let filteredData = originalData.filter((subservice) =>
      subservice.name.toLowerCase().includes(value.toLowerCase())
    );
    setTestPrepData(filteredData);
  };

  // Detals Data
  const handleOpenDetailspopup = (rowData, headerName, headerValue) => {
    setDetailsPopup(true);
    setRowData(rowData);
    setSelectedHeader(headerName);
    setSelectedHeaderValue(headerValue);
  };

  const handleCloseDetailspopup = (rowData, headerName) => {
    setDetailsPopup(false);
  };

  const handleGetDetailsData = async (rowData, headerName, headerValue) => {
    setDetailsLoading(true);

    // Handle form submission logic here

    const token = getTokenOrLogout();
    if (!token) return;
    let headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json", // Make sure to keep the content type
    };

    const requestData = {
      user_id: parseInt(userId),
      filter: selectedOption,
      from_date: fromDate,
      to_date: toDate,
      filter_type: headerValue,
      sub_service_id: rowData?.id,
    };

    try {
      const response = await fetch(
        `${API_ENDPOINT}reports/getsvoreportwithsubservice-with-detail`,
        {
          method: "POST",
          headers,
          body: JSON.stringify(requestData),
        }
      );

      const result = await response.json();
      if (response.ok) {
        setDetailsData(result);
        setDetailsLoading(false);
        handleOpenDetailspopup(rowData, headerName, headerValue);
      } else {
        setDetailsLoading(false);
        showSnackbar(result.message, "error");
      }
    } catch (error) {
      setLoading(false);
      console.error("Error:", error);
      showSnackbar(" Error", "error");
    }
  };

  return (
    <>
      <LoaderComp isLoading={testprepLoading || detailsLoading} />

      <Grid container spacing={2}>
        <Grid item xs={12} lg={2} sm={4} md={3}>
          <HeadingCard>
            <Typography variant="h3" textAlign="center">
              {" "}
              SVO Report
            </Typography>
          </HeadingCard>
        </Grid>
        <Grid item xs={12} lg={12} md={12} sm={12}>
          <MainCard>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={4} md={4} lg={3}>
                <Typography variant="h6">Select Date</Typography>
                <Select
                  size="normal"
                  fullWidth
                  value={selectedOption}
                  style={{ borderRadius: "10px" }}
                  onChange={handleClick}
                >
                  <MenuItem value="today">Today</MenuItem>
                  <MenuItem value="currentweek">
                    This Week ({weekRange})
                  </MenuItem>
                  <MenuItem value="currentmonth">
                    This Month({currentMonthName})
                  </MenuItem>

                  <MenuItem value="pastmonth">
                    Last Month({lastMonthName})
                  </MenuItem>
                  <MenuItem value="custom">Custom</MenuItem>
                </Select>
              </Grid>

              {selectedOption === "custom" && (
                <>
                  <Grid item xs={6} lg={3} md={4} sm={4}>
                    <Typography variant="h5">From Date</Typography>
                    <CustomTextFieldComp
                      size="normal"
                      value={fromDate}
                      onChange={handleChangeFromDate}
                      fullWidth
                      type="date"
                      InputProps={{
                        style: { borderRadius: "10px" },
                        inputProps: { max: today },
                      }}
                    />
                  </Grid>
                  <Grid item xs={6} lg={3} md={4} sm={4}>
                    <Typography variant="h5">To Date</Typography>
                    <CustomTextFieldComp
                      size="normal"
                      value={toDate}
                      onChange={handleChangeToDate}
                      fullWidth
                      type="date"
                      InputProps={{
                        style: { borderRadius: "10px" },
                        inputProps: { max: today },
                      }}
                    />
                  </Grid>
                </>
              )}
              <Grid item xs={12} lg={3} md={12} sm={12}>
                <Typography sx={{ visibility: "hidden" }}>To Date</Typography>
                <Grid container gap={2} ml={1}>
                  <SearchButton
                    label="Search"
                    onClick={handleSubmitTestprep}
                    showIcon={true}
                  />
                </Grid>
              </Grid>
            </Grid>
          </MainCard>
        </Grid>

        {/* <Grid item xs={12} lg={12} md={12} sm={12}>
          <MainCard>
            {!loading && svoReportData.length === 0 ? (
              <Typography variant="h4">No SVO Data Found</Typography>
            ) : !loading && svoReportData.length !== 0 ? (
              <Grid container spacing={2}>
                <Grid item xs={12} lg={12} md={12} sm={12}>
                  <Button
                    variant="outlined"
                    size="small"
                    style={{
                      borderRadius: "25px",
                      borderColor: "#b2b2b4",
                      fontWeight: 600,
                    }}
                    startIcon={<SettingsOutlinedIcon />}
                    endIcon={<LaunchOutlinedIcon />}
                    onClick={handleSubmitTestprep}
                  >
                    Test Preparation
                  </Button>
                </Grid>
                <Grid item xs={6} lg={3} md={4} sm={4}>
                  <InfoCard
                    name="Client Count"
                    value={svoReportData.totalEnquiries}
                    backGround="#D5F6E1"
                  />
                </Grid>
                <Grid item xs={6} lg={3} md={4} sm={4}>
                  <InfoCard
                    backGround="#E7F3FF"
                    name="Super Prospective"
                    value={svoReportData.superprospectiveCount}
                  />
                </Grid>
                <Grid item xs={6} lg={3} md={4} sm={4}>
                  <InfoCard
                    backGround="#FFEDFB"
                    name="Demo Scheduled"
                    value={svoReportData.demoBookedCount}
                  />
                </Grid>
                <Grid item xs={6} lg={3} md={4} sm={4}>
                  <InfoCard
                    backGround="#FFF6E2"
                    name="Enrolled"
                    value={svoReportData.enrolledCount}
                  />
                </Grid>
              </Grid>
            ) : (
              <Typography variant="h4">No SVO Data Found</Typography>
            )}
          </MainCard>
        </Grid> */}

        <Grid item xs={12}>
          <MainCard>
            <Grid container>
              <Grid item xs={12} textAlign="end">
                <SearchTextFieldComp onChange={handleChangeNmae} />
              </Grid>
              <Grid item xs={12}>
                <DataGrid
                  rows={testpreData}
                  columns={columns}
                  autoHeight
                  getRowId={() => Math.floor(Math.random() * 100000000)}
                  slots={{
                    noRowsOverlay: CustomNoRowsOverlay,
                  }}
                  initialState={{
                    pagination: {
                      paginationModel: {
                        pageSize: 25,
                      },
                    },
                  }}
                  sx={{ marginTop: "20px" }}
                />
              </Grid>
            </Grid>
          </MainCard>
        </Grid>
      </Grid>

      <CustomPopup
        open={open}
        onClose={handleClose}
        component={
          <SvoReportTable onClose={handleClose} testpreData={testpreData} />
        }
        title="Test Preparation"
        maxWidth="md"
        showDivider={true}
      />

      <CustomPopup
        open={detailspopup}
        onClose={handleCloseDetailspopup}
        component={
          selectedHeaderValue === "client_count" ||
          selectedHeaderValue === "recycled" ||
          selectedHeaderValue === "super_prospective" ? (
            <NewEnquiryComp
              onClose={handleCloseDetailspopup}
              selectedFilter={selectedOption}
              SelectedData={detailsData}
              fromDate={fromDate}
              toDate={toDate}
            />
          ) : selectedHeaderValue === "demo_scheduled" ? (
            <DemoDetails
              onClose={handleCloseDetailspopup}
              SelectedData={detailsData}
              selectedFilter={selectedOption}
              fromDate={fromDate}
              toDate={toDate}
            />
          ) : (
            <EnrollDetails
              onClose={handleCloseDetailspopup}
              SelectedCardData={detailsData}
              selectedFilter={selectedOption}
              fromDate={fromDate}
              toDate={toDate}
            />
          )
        }
        title={`${selectedHeader} Details`}
        maxWidth="md"
        showDivider={true}
      />

      <CustomSnackbar
        open={snackbarOpen}
        onClose={() => setSnackbarOpen(false)}
        message={snackbarMessage}
        severity={snackbarSeverity}
      />
    </>
  );
}
